import { GeneralStyle } from '@website-builder/model/style/general-style';

export class TableStyle extends GeneralStyle {
  style = 'uk-table-striped';
  tableHover = '';
  justify = '';
  rowHeight = 50;
  verticalAlignment = 'uk-table-middle';
  responsive = '';
  horizontalAlignment = '';
  verticalBorders = '';

  static normalize(styles: Partial<TableStyle>): TableStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const tableStyles = new TableStyle();

    Object.assign(tableStyles, generalStyle);

    tableStyles.style = styles.style ?? tableStyles.style;
    tableStyles.tableHover = styles.tableHover ?? tableStyles.tableHover;
    tableStyles.justify = styles.justify ?? tableStyles.justify;
    tableStyles.rowHeight = styles.rowHeight ?? tableStyles.rowHeight;
    tableStyles.verticalAlignment = styles.verticalAlignment ?? tableStyles.verticalAlignment;
    tableStyles.responsive = styles.responsive ?? tableStyles.responsive;
    tableStyles.horizontalAlignment = styles.horizontalAlignment ?? tableStyles.horizontalAlignment;
    tableStyles.verticalBorders = styles.verticalBorders ?? tableStyles.verticalBorders;

    return tableStyles;
  }
}
